// removed by extract-text-webpack-plugin
module.exports = {"item":"ResultsList-module-item-36FZH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ResultsList/ResultsList.module.scss
// module id = 911
// module chunks = 0